var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "600",
      "persistent": ""
    },
    on: {
      "input": _vm.closeModal
    }
  }, [_c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.isShowMode ? 'Show' : _vm.isEdit ? 'Редактировать' : 'Добавить') + " ")]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-container', {
    staticClass: "px-0"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.isShowMode,
      "label": "Name",
      "placeholder": "Add name",
      "error-messages": _vm.errorMessages.name
    },
    on: {
      "input": function input($event) {
        return _vm.$v.role.name.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.role.name.$touch();
      }
    },
    model: {
      value: _vm.role.name,
      callback: function callback($$v) {
        _vm.$set(_vm.role, "name", $$v);
      },
      expression: "role.name"
    }
  })], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.isShowMode ? 'Закрыть' : 'Отменить'))]), !_vm.isShowMode ? _c('v-btn', {
    attrs: {
      "loading": _vm.saveBtnLoading,
      "disabled": _vm.isShowMode,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveRole
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Сохранить' : 'Создать') + " ")]) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }